import Vue from 'vue'
import BootstrapVue, {IconsPlugin} from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/css/bootstrap.min.css'

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
